import { React, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Authenticator, CheckboxField, useAuthenticator, Button } from '@aws-amplify/ui-react';
import { Amplify } from 'aws-amplify';
import outputs from './amplify_outputs.json';
import '@aws-amplify/ui-react/styles.css';
import { View, Image, Text, useTheme } from '@aws-amplify/ui-react';
import { ThemeProvider } from '@mui/material/styles';
import { dashboardTheme } from './theme';
// import { Button } from '@mui/material';

import Summary from './components/Summary/Summary';
import Layout from './components/Layout/Layout';
import AboutUs from './components/AboutUs/AboutUs';
import RelatedLinks from './components/RelatedLinks/RelatedLinks';
import gemmaAllBrands from '../src/images/logos/GEMMAplussubbrands.jpg';
import TourGuide from './components/TourGuide/TourGuide';

Amplify.configure(outputs);

const components = {
  Header() {
    const { tokens } = useTheme();
    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Image alt="GEMMA logo" src={gemmaAllBrands} />
      </View>
    );
  },

  Footer() {
    const { tokens } = useTheme();
    return (
      <View textAlign="center" padding={tokens.space.large}>
        <Text color={tokens.colors.neutral[80]}>&copy; All Rights Reserved</Text>
      </View>
    );
  },

  SignUp: {
    FormFields() {
      const { validationErrors } = useAuthenticator();

      const [termsOpened, setTermsOpened] = useState(false);
      const [termsChecked, setTermsChecked] = useState(false);
      const [showModal, setShowModal] = useState(false);

      return (
        <>
          {/* Default sign-up fields */}
          <Authenticator.SignUp.FormFields />

          {/* Open Terms & Conditions modal */}
          <Button type="button" onClick={() => setShowModal(true)} className="mb-2">
            Read Terms and Conditions
          </Button>

          {/* Checkbox disabled until terms opened */}
          <CheckboxField
            name="custom:termsAccepted"
            value="true"
            label="I agree with the Terms and Conditions"
            isDisabled={!termsOpened}
            checked={termsChecked}
            onChange={(e) => setTermsChecked(e.target.checked)}
            hasError={!!validationErrors?.['custom:termsAccepted']}
            errorMessage={validationErrors?.['custom:termsAccepted']}
          />

          {/* Force-disable the Create Account button until opened + checked */}
          <style>
            {`
              button[type="submit"] {
                background-color: ${termsOpened && termsChecked ? '#1976d2' : '#ccc'} !important;
                pointer-events: ${termsOpened && termsChecked ? 'auto' : 'none'} !important;
                cursor: ${termsOpened && termsChecked ? 'pointer' : 'not-allowed'} !important;
              }
            `}
          </style>

          {/* Simple modal */}
          {showModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white p-6 rounded shadow-md max-w-lg">
                <h2 className="text-lg font-bold mb-2">Terms and Conditions</h2>
                <p className="mb-4">
                  Here you put your full Terms and Conditions text. Scroll or read carefully.
                </p>
                <Button
                  onClick={() => {
                    setTermsOpened(true);
                    setShowModal(false);
                  }}
                >
                  I have read and understood
                </Button>
              </div>
            </div>
          )}
        </>
      );
    },
  },
};

export default function App() {
  const [runTour, setRunTour] = useState(false);

  return (
    <ThemeProvider theme={dashboardTheme}>
    <Authenticator
      initialState="signUp"
      components={components}
      services={{
        async validateCustomSignUp(formData) {
          if (!formData['custom:termsAccepted']) {
            return {
              'custom:termsAccepted': 'You must agree to the Terms and Conditions',
            };
          }
        },
      }}
    >
      {({ signOut, user }) => (
        <>
          <TourGuide run={runTour} setRun={setRunTour} />
          <Router>
            <Layout signOut={signOut} user={user}>
              <Routes>
                <Route path="/" element={<Summary />} />
                <Route path="/AboutUs" element={<AboutUs />} />
                <Route path="/RelatedLinks" element={<RelatedLinks />} />
              </Routes>
            </Layout>
          </Router>
        </>
      )}
    </Authenticator>
    </ThemeProvider>
  );
}
